module.exports = __webpack_public_path__ + "static/media/S-10-Y.7907e428.mp3";